// removed by extract-text-webpack-plugin
module.exports = {"root":"Charity__root___35Wj8","logo":"Charity__logo___33ahJ"};


//////////////////
// WEBPACK FOOTER
// ./app/views/Charity/Charity.css
// module id = 106
// module chunks = 0